import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { storeQueries } from '@as-react/common-queries';
import { LocationSearchType, PDPVersion, ProductTypes, StoreFinderType, } from '@as-react/common-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreFinderPopup } from '../components/product-detail/store-finder-popup/StoreFinderPopup';
import { SELECTED_STORE_STORAGE_KEY } from '../constants/StorageKeysConstants';
import { ProductAddToBasketLocations } from '../enums/ActionEnums';
import { useOAuth } from '../hooks/useOAuth';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { makeGetBasketCCPopupState, makeGetBasketMappedProductsState } from '../redux/basket/selectors/BasketSelector';
import customerActions from '../redux/customer/actions/CustomerActions.creators';
import { makeGetCustomerProfile } from '../redux/customer/selectors/CustomerSelector';
import { makeGetPriceInformation, makeGetProductFulfillmentBySize, makeGetProductInfo, makeGetSelectedSku, makeGetSpecialtyType, } from '../redux/product/selectors/ProductSelector';
import LocalStorageUtil from '../util/LocalStorageUtil';
import { useProductDetailContext } from './product/ProductDetailV2Container';
const StoreFinderContainer = ({ type = StoreFinderType.CLICK_AND_COLLECT, }) => {
    var _a, _b, _c;
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint, businessUnitId, isShopLanding, fictiveWebShop, pageInfo } = aemConfiguration;
    const dispatch = useDispatch();
    const popupState = useSelector(makeGetBasketCCPopupState());
    const profile = useSelector(makeGetCustomerProfile());
    const { isLoggedIn } = useOAuth();
    const selectedSku = useSelector(makeGetSelectedSku());
    const priceInformation = useSelector(makeGetPriceInformation());
    const fulfillmentBySize = useSelector(makeGetProductFulfillmentBySize());
    const { selectedAdditionalProducts } = useProductDetailContext();
    const productInfo = useSelector(makeGetProductInfo());
    const { isPDPPage } = pageInfo;
    const specialtyType = useSelector(makeGetSpecialtyType());
    const products = useSelector(makeGetBasketMappedProductsState());
    useEffect(() => {
        if (!profile && isLoggedIn) {
            dispatch(customerActions.getProfile());
        }
    }, [profile, isLoggedIn]);
    const [locationSearchParams, setLocationSearchParams] = useState();
    const { getClickAndCollectStoresOpeningsHours } = storeQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const productData = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productId) && isPDPPage
        ? [
            {
                skuId: Number(selectedSku),
                productId: Number(productInfo.productId),
                colorId: Number(productInfo.selectedColorId),
                quantity: 1,
            },
        ]
        : products
            .filter(product => product.productType === ProductTypes.PRODUCT)
            .map(product => ({
            skuId: Number(product.sku),
            productId: Number(product.productId),
            colorId: Number(product.colorId),
            quantity: product.quantity,
        }));
    const isSpecialtyTypeProducts = !!specialtyType || (!isPDPPage && !!products.find(product => product.specialtyStoreProduct));
    const isShowStock = locationSearchParams ? locationSearchParams.isShowStock : isSpecialtyTypeProducts && isPDPPage;
    const isEnabled = !popupState.collapsed &&
        locationSearchParams &&
        !!((_a = locationSearchParams.locationSearch) === null || _a === void 0 ? void 0 : _a.location) &&
        productData.length > 0;
    const storesQueryResult = useQuery(getClickAndCollectStoresOpeningsHours({
        businessUnitId,
        fictiveShopId: fictiveWebShop,
        productData,
        location: ((locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch) || {}).location,
        onlyInStock: specialtyType ? false : isShowStock,
        onlyInSpecialtyStore: Boolean(isPDPPage && isShowStock && (!!specialtyType || isSpecialtyTypeProducts)),
        sortBy: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.sortBy) || 'distance',
        isShopLanding,
        selectedStoreId: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch.type) &&
            (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch.type) === LocationSearchType.CUSTOM_SEARCH
            ? undefined
            : (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.selectedStoreId) ||
                ((_b = LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY)) === null || _b === void 0 ? void 0 : _b.storeId),
    }, {
        enabled: Boolean(isEnabled),
    }));
    const handleSearch = (searchParams) => {
        setLocationSearchParams(searchParams);
    };
    const handleStoreSelect = () => {
        if (type === StoreFinderType.CLICK_AND_COLLECT) {
            const quantity = 1;
            dispatch(selectedAdditionalProducts.length > 0
                ? basketActions.createAddAdditionalProductsAction(selectedAdditionalProducts, quantity, ProductAddToBasketLocations.CLICK_AND_COLLECT)
                : basketActions.createAddAction(quantity, ProductAddToBasketLocations.CLICK_AND_COLLECT, PDPVersion.V2));
        }
        if (type === StoreFinderType.BASKET) {
            dispatch(basketActions.createGetAction());
        }
    };
    const handleClosePopup = () => dispatch(basketActions.createCCPopupCloseAction());
    return (_jsx(StoreFinderPopup, { type: type, isOpen: !popupState.collapsed, disabledCTA: Boolean(!((_c = priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices) === null || _c === void 0 ? void 0 : _c.SELL)), storeSourceExcluded: Boolean(fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded), handleClosePopup: handleClosePopup, onSearch: handleSearch, onStoreSelect: handleStoreSelect, storesQueryResult: storesQueryResult }));
};
export default StoreFinderContainer;
